import {
  CommunicationThreadBody,
  useCommunicationThreadTitle,
} from "@/components/communications/CommunicationThreadBody.tsx";
import { SidebarContent } from "@/components/ui/sidebar.tsx";
import { RightSidebarHeader } from "./elements.tsx";
import { useRightSidebar } from "./hooks.tsx";
import type { CommunicationThreadSidebarSchema } from "./sidebarSchema.ts";

/**
 * A conversation in the right sidebar: the shared
 * {@link CommunicationThreadBody} in the sidebar's own chrome.
 *
 * Reached only by a hand-written or stale `sb_type=communicationThread` URL.
 * Nothing opens the sidebar for a conversation any more — a contact's activity
 * row navigates to the conversation's own path and lets the surrounding boundary
 * choose between a canvas card and the page. Kept so those URLs still resolve to
 * the conversation rather than to an empty panel.
 */
export const CommunicationThreadSidebar = ({
  communicationId,
}: CommunicationThreadSidebarSchema) => {
  const { closeSidebar } = useRightSidebar();
  const title = useCommunicationThreadTitle(communicationId);

  return (
    <>
      <RightSidebarHeader title={title} handleClose={closeSidebar} />
      <SidebarContent className="@container px-4 py-4">
        <CommunicationThreadBody communicationId={communicationId} />
      </SidebarContent>
    </>
  );
};
